export const environmentData = {
  run: 'development',
  development: {
    clientId: '1d1652fd-aa64-4e1f-9b07-6d3ee45527bf',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid 1d1652fd-aa64-4e1f-9b07-6d3ee45527bf/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=05135d80-faac-481e-bfbb-2336ef105bb2;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    apiBaseURL: 'https://cpsistoreiotappserviceapi.azurewebsites.net/api',
  },
  staging: {
    clientId: '1d1652fd-aa64-4e1f-9b07-6d3ee45527bf',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid 1d1652fd-aa64-4e1f-9b07-6d3ee45527bf/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=05135d80-faac-481e-bfbb-2336ef105bb2;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    apiBaseURL: 'https://dev-api-execdb-ps.azurewebsites.net/api',
  },
  production: {
    clientId: '1d1652fd-aa64-4e1f-9b07-6d3ee45527bf',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid 1d1652fd-aa64-4e1f-9b07-6d3ee45527bf/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=6e141473-8dda-4a09-849d-bbe0127c40a0;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    apiBaseURL: 'https://cpsistoreiotappserviceapi.azurewebsites.net/api',
  },
}
